window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swat) {
  // Product details page
  var pdpAddToWishlist = document.getElementById("swym-pdp-add-to-list");
  if(pdpAddToWishlist) {
    var empi = parseInt(pdpAddToWishlist.dataset["productId"]);
    var currentEpi = parseInt(pdpAddToWishlist.dataset["variantId"]);
    swat.evtLayer.addEventListener('sw:variantchanged', function(e) {
      var p = e.detail.d;
      currentEpi = p.variant.id;
      pdpAddToWishlist.setAttribute("data-variant-id", currentEpi);
      pdpAddToWishlist.dataset["variantId"] = currentEpi;
    });
    if(!currentEpi) {
      swat.platform.getBaseEpiMultiVariantProduct(function(epi) {
        currentEpi = epi;
        pdpAddToWishlist.setAttribute("data-variant-id", currentEpi);
        pdpAddToWishlist.dataset["variantId"] = currentEpi;
      });
    }
  }
  // All other buttons
  SwymUtils.addDOMEventListener(".swym-add-to-list-button", "click", function(evt) {
    var empi = parseInt(evt.currentTarget.dataset["productId"]);
    var epi = parseInt(evt.currentTarget.dataset["variantId"]);
    var du = evt.currentTarget.dataset["url"] || (window.location.origin + "/products/" + evt.currentTarget.dataset["handle"]);
    var cprops = evt.currentTarget.dataset["cprops"] ? JSON.parse(evt.currentTarget.dataset["cprops"]) : {};
    if(!epi) {
      SwymUtils.log("Please select a variant to add to list");
      alert("Please select a variant to add to list");
    }
    if(!du) {
      throw new Error("Product url or handle not set for button");
    }
    var containerElem = evt.currentTarget.parentNode.querySelector(".pdp-wishlist-form");
    var p = {epi: epi, empi: empi, du: du, cprops: cprops}
    swat.ui.performAddToWishlist(p, function (evt) {console.log("Added to list", arguments)}, function (evt) {console.log("Failed adding to list", arguments)});
  });
})